<template>
<b-container class="pt-5">
  <b-row>
    <b-col cols="3" md="2">
      <h5 class="pl-3">Languages</h5> 
      <b-nav vertical>
	<!-- restful: query in url for each language -->
        <b-nav-item to="/privacy?language=english" @click.native="scrollToTop()">English</b-nav-item>
	<b-nav-item to="/privacy?language=dutch" @click.native="scrollToTop()">Nederlandse</b-nav-item>
        <b-nav-item to="/privacy?language=german" @click.native="scrollToTop()">Deutsch</b-nav-item>
        <b-nav-item to="/privacy?language=spanish" @click.native="scrollToTop()">Español</b-nav-item>
        <b-nav-item to="/privacy?language=french" @click.native="scrollToTop()">Français</b-nav-item>                
        <b-nav-item to="/privacy?language=italian" @click.native="scrollToTop()">Italiano</b-nav-item>
      </b-nav>
    </b-col>
    <b-col cols="9" md="10">
      <!-- v-if for each language component -->
      <privacyEnglish v-if="language === 'english'"/>
      <privacyDutch v-if="language === 'dutch'"/>
      <privacyGerman v-if="language === 'german'"/>
      <privacySpanish v-if="language === 'spanish'"/>
      <privacyFrench v-if="language === 'french'"/>
      <privacyItalian v-if="language === 'italian'"/>
    </b-col>   
  </b-row>
</b-container>
</template>

<script>
import privacyEnglish from '@/components/privacy-english.vue';
import privacyGerman from '@/components/privacy-german.vue';
import privacySpanish from '@/components/privacy-spanish.vue';
import privacyFrench from '@/components/privacy-french.vue';
import privacyItalian from '@/components/privacy-italian.vue';
import privacyDutch from '@/components/privacy-dutch.vue';
export default {
    name: 'privacyStatement',
    data: function () {
	return {
	    // this language key is where the v-if is reading from
	    language: "english"
	}
    },
    components: {
	privacyEnglish,
	privacyGerman,
	privacySpanish,
	privacyFrench,
	privacyItalian,
	privacyDutch
    },
    watch: {
	'$route' (to, from) {
	    // set the language value to the query in the url
	    this.language = to.query.language;
	}
    },
    methods: {
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.nav-link.active {
    font-size: 1rem;
    font-weight: 400;
    color: #595959 !important;
}
</style>
